import { T } from "@freightsimple/ui-core/Typography/T";
import type { TrackingLine } from "@freightsimple/generated-dashboard-openapi-client/models/TrackingLine";
import moment from "moment";

interface MostRecentTrackingLineProps {
  mostRecentTrackingLine: TrackingLine | undefined;
}

export function ShipmentMostRecentTrackingLine(
  props: MostRecentTrackingLineProps,
) {
  const { mostRecentTrackingLine } = props;

  if (mostRecentTrackingLine === undefined) {
    return <></>;
  }

  function formatDate(date: Date) {
    return moment(date).format("dddd, MMMM Do YYYY, h:mma");
  }

  return (
    <div className="flex flex-col items-start">
      <div className="-mb-1 text-sm font-normal text-foreground">
        Latest Update
      </div>
      <T size="2xl" weight="normal">
        {mostRecentTrackingLine.message}
      </T>
      <T size="xs" weight="normal">
        {formatDate(mostRecentTrackingLine.timestamp)}
      </T>
      <div className="h-[24px]" />
    </div>
  );
}
